var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//TODO: refactor and move to sg-ui-components
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { CMSContent, ContentBox, ContentBoxBody, ContentBoxHead, getCMSObject, TeleScript, ReadyToGo, CantFindConfirmation } from '../../../index';
/**********************************************************************
 * Component:  AwaitAccountConfirmation
 * Purpose:    Simple Component that tells user to wait for their
 *             account confirmation email.    The user has the option to
 *             resend the email if it hasn't come in.
 *
 * Props:       user -  user data store
 *              actions - store actions (apis)
 *              config -  front-end configuration object
 *              cmsSourceFirebase - CMS firebase store
 *
 */
var AwaitAccountConfirmation = function (_a) {
    var _b;
    var user = _a.user, actions = _a.actions, config = _a.config, cmsSourceFirebase = _a.cmsSourceFirebase;
    var _c = useState(0), seconds = _c[0], setSeconds = _c[1];
    var _d = useState(true), timerActive = _d[0], setTimerActive = _d[1];
    var _e = useState(false), timeoutHit = _e[0], setTimeoutHit = _e[1];
    var _f = useState(false), accountConfirmed = _f[0], setAccountConfirmed = _f[1];
    var timeout = config.config.account_confirm_wait_seconds;
    var accountConfirmationTelescript = getCMSObject('data.components.teleScripts.accountConfirmation.jsonBlock');
    var cantFindConfirmationTeleScript = getCMSObject('data.components.teleScripts.cantFindConfirmation.jsonBlock');
    var readyToGoTeleScript = getCMSObject('data.components.teleScripts.readyToGo.jsonBlock');
    //***********************************************************************************
    // Request a resend of the confirmation email and reset timer to 0
    var resendConfirmationEmail = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    return [4 /*yield*/, actions.loadingActions.setLoading({ action: 'confirmResend' })];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, actions.userActions.updateSection({ section: 'resend-confirm-email', status: 'initial' })];
                case 2:
                    _c.sent();
                    payload = {
                        registrar_id: (_b = (_a = user === null || user === void 0 ? void 0 : user.player) === null || _a === void 0 ? void 0 : _a.registrar_id) !== null && _b !== void 0 ? _b : '',
                    };
                    return [4 /*yield*/, actions.userActions.confirmResend(payload)];
                case 3:
                    _c.sent();
                    setSeconds(0);
                    return [2 /*return*/];
            }
        });
    }); };
    //***********************************************************************************
    // Check to see if the actions table for the user has changed, if so and they
    // no longer have the account-confirm action - load up Your Ready to Go component
    var checkVerificationStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!((_a = user === null || user === void 0 ? void 0 : user.player) === null || _a === void 0 ? void 0 : _a.actions)) return [3 /*break*/, 3];
                    if (!!user.player.actions.includes('account-confirm')) return [3 /*break*/, 1];
                    setTimerActive(false);
                    setAccountConfirmed(true);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, actions.userActions.getPlayerData()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (typeof timeout === 'undefined') {
            return;
        }
        var numericTimeout = Number(timeout);
        if (isNaN(numericTimeout)) {
            console.error('Invalid timeout prop provided:', timeout);
            return;
        }
        var interval = null;
        if (timerActive && seconds < numericTimeout) {
            interval = setInterval(function () {
                setSeconds(function (prevSeconds) { return prevSeconds + 10; });
                checkVerificationStatus();
            }, 10000);
        }
        else if (seconds >= numericTimeout) {
            setTimerActive(false);
            setTimeoutHit(true);
        }
        return function () {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [timerActive, seconds, timeout]);
    if (accountConfirmed) {
        return _jsx(ReadyToGo, { config: config, telescript: readyToGoTeleScript, cmsSourceFirebase: cmsSourceFirebase, user: user, actions: actions });
    }
    else if (timeoutHit) {
        return _jsx(CantFindConfirmation, { cmsSourceFirebase: cmsSourceFirebase, telescript: cantFindConfirmationTeleScript });
    }
    else {
        return (_jsx("div", { className: 'row justify-content-center', children: _jsx("div", { className: 'col-12 col-md-10 col-lg-8', children: _jsxs(ContentBox, { variant: 'theme-primary', children: [_jsx(ContentBoxHead, { children: "Welcome!" }), _jsxs(ContentBoxBody, { children: [_jsx("div", { className: 'text-center', children: _jsx(CMSContent, { localStorageObject: 'webContent', contentPath: 'data.sitewideSettings.mainLogo.image', className: 'img-fluid', cmsSourceFirebase: cmsSourceFirebase }) }), _jsxs(TeleScript, { line: accountConfirmationTelescript === null || accountConfirmationTelescript === void 0 ? void 0 : accountConfirmationTelescript.accountCreatedNextSteps, children: [_jsxs("p", { className: 'text-center', children: ["Your account has been created. Follow the link sent to ", _jsx("strong", { children: (_b = user === null || user === void 0 ? void 0 : user.player) === null || _b === void 0 ? void 0 : _b.email }), " to confirm your registration and begin earning Rewards. Please allow up to 15 minutes to receive your email."] }), _jsx("p", { className: 'text-center', children: "Didn't receive your confirmation email?" }), _jsx("p", { className: 'text-center', children: _jsx(Link, { to: '#', onClick: resendConfirmationEmail, children: _jsx("button", { type: 'button', className: 'resend-confirm-email-btn', children: "Resend Confirmation Email" }) }) }), _jsx("p", { className: 'text-center', children: "Wrong email?" }), _jsx("p", { className: 'text-center', children: _jsx(Link, { to: '/feedback#contact', children: _jsx("button", { type: 'button', className: 'edit-email-btn', children: "Edit Email Address" }) }) })] })] })] }) }) }));
    }
};
export default AwaitAccountConfirmation;
